module.exports = __webpack_public_path__ + "media/images/weather/401_day-412fe524e8af4f8ce820cc033429ff8f.png";